
import React from "react";
import Translate from "../Multilanguage/Translate";
import { ReactComponent as CloseIcon } from "../../assets/Icons/close.svg";
import { setAgeConfirmedForSession } from "../../utils/ageConfirmation";

const AgeConfirmModal = ({ onConfirm, onCancel }) => {
  const confirmHandler = () => {
    setAgeConfirmedForSession();
    onConfirm?.();
  };

  const declineHandler = () => {
    onCancel?.();
  };

  return (
    <div className="ageConfirmModal" role="dialog" aria-modal="true" aria-label="Age Confirmation">
      <div className="overlayModal"></div>
      <div className="contents">
        <div className="closeContainer" onClick={declineHandler}>
          <CloseIcon />
        </div>
        <h3><Translate textKey={'age_confirmation_title'} /></h3>
        <h1><Translate textKey={'age_confirmation_message'} /></h1>
        <div className="buttons">
          <div className="buttonContainer" onClick={declineHandler}>
            <div className="background"></div>
            <button><Translate textKey={'age_confirmation_no'} /></button>
          </div>

          <div className="buttonContainer" onClick={confirmHandler}>
            <div className="background"></div>
            <button><Translate textKey={"age_confirmation_yes"} /></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgeConfirmModal;
